export const TOGGLE_LOADING = 'admission/TOGGLE_LOADING'
export const GET_APPLICATION = 'admission/GET_APPLICATION'
export const SET_APPLICATION = 'admission/SET_APPLICATION'
export const GET_STATIC_OPTIONS = 'admission/GET_STATIC_OPTIONS'
export const SET_OPTIONS = 'admission/SET_OPTIONS'
